module.exports = __webpack_public_path__ + "static/media/scenario-paper.4bab3ed0.svg";